
document.addEventListener('DOMContentLoaded', function() {
    fetch('/assets/tawseel_app/icons/icons.svg')
        .then(response => response.text())
        .then(svg => {
            const div = document.createElement('div');
            div.innerHTML = svg;
            div.style.display = 'none';
            document.body.appendChild(div);
        });
});